export default "__VITE_ASSET__DvlVvN9x__"